// third-party
import { combineReducers } from "redux";

// project import
import menu from "./menu";
import snackbar from "./snackbar";
import order from "./order";
import sale from "./sale";
import list from "./list";
import data from "./data";
import user from "./user";
import smartlead from "./smartlead";

const reducers = combineReducers({
  menu,
  snackbar,
  order,
  sale,
  list,
  data,
  user,
  smartlead,
});

export default reducers;
